import { jsx } from "react/jsx-runtime";
import { Icon, Menu } from "@blueprintjs/core";
import React from "react";
import { createCommandMenu } from "@teselagen/ui";
import viewSubmenu from "../MenuBar/viewSubmenu";
import getCommands from "../commands";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
import withEditorProps from "../withEditorProps";
export default connectToEditor(({ toolBar = {} }) => {
  return {
    isOpen: toolBar.openItem === "visibilityTool"
  };
})(({ toolbarItemProps, isOpen }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { icon: "eye-open" }),
        onIconClick: "toggleDropdown",
        Dropdown: VisibilityOptions,
        noDropdownIcon: true,
        toggled: isOpen,
        tooltip: isOpen ? "Hide Visibility Options" : "Show Visibility Options",
        ...toolbarItemProps
      }
    }
  );
});
const VisibilityOptions = withEditorProps(function(props) {
  return /* @__PURE__ */ jsx(Menu, { children: createCommandMenu(viewSubmenu, getCommands({ props }), {
    useTicks: true,
    omitIcons: true
  }) });
});
